module.exports = __webpack_public_path__ + "static/media/bg@3x.08ed5664.png";


//////////////////
// WEBPACK FOOTER
// ./src/custom/livres/img/bg@3x.png
// module id = 768
// module chunks = 0